import {
  GET_LOGIN_BANNERS_REQUEST,
  GET_LOGIN_BANNERS_SUCCESS,
  GET_LOGIN_BANNERS_ERROR,
} from '../actions';

const initialState = {
  banners: [],
  areBannersLoading: false,
};

export const LoginPage = (state = initialState, action) => {
  switch (action.type) {
    case GET_LOGIN_BANNERS_REQUEST:
      return {
        ...state,
        areBannersLoading: true,
      };

    case GET_LOGIN_BANNERS_SUCCESS:
      return {
        ...state,
        areBannersLoading: false,
        banners: action.payload,
      };

    case GET_LOGIN_BANNERS_ERROR:
      return {
        ...state,
        areBannersLoading: false,
      };

    default:
      return state;
  }
};
